import classes from 'components/pages/Unsubscribe/Unsubscribe.module.scss';
import React from 'react';
import { graphql, useLazyLoadQuery } from 'react-relay';
import useQueryStringParams from 'hooks/useQueryStringParams';
import UnsubscribeCard from 'components/organisms/Unsubscribe/UnsubscribeCard';
import { UnsubscribeViaTokenQuery } from './__generated__/UnsubscribeViaTokenQuery.graphql';
import Logo from 'components/assets/lifepoints-logo.svg';
import Txt from 'components/atoms/Txt/Txt';
import A from 'components/atoms/A/A';

export type Props = {};

export default function Unsubscribe({}: Props) {
  const queryParams = useQueryStringParams();

  const data = useLazyLoadQuery<UnsubscribeViaTokenQuery>(
    graphql`
      query UnsubscribeViaTokenQuery($input: NotificationsSubscriptionsViaToken!) {
        notificationSubscriptionsViaToken(input: $input) {
          ...UnsubscribeCard_notificationSubscriptions
        }
      }
    `,
    {
      input: {
        token: queryParams['token'],
      },
    },
  );

  return (
    <div className={classes.root}>
      <div className={classes.background} />
      <div className={classes.menuWrapper}>
        <div className={classes.header}>
          <Logo id="logo" width={150} height={50} />
          <div className={classes.menu}>
            <p>
              <Txt className={classes.alreadyAMember}>Already a LifePoints member?</Txt>
              <A className={classes.signUpLink} href={'/login'}>
                <Txt>sign in</Txt>
              </A>
            </p>
          </div>
        </div>

        <UnsubscribeCard
          notificationsSubscriptionsRef={data.notificationSubscriptionsViaToken}
          className={classes.card}
        />
      </div>
    </div>
  );
}
